import { useNavigate } from "react-router-dom";

export default function PageTitleWithBack({ title, onBack }) {
  const navigate = useNavigate();

  return (
    <div className="flex mb-4 p-2 gap-2">
      <button
        onClick={onBack || (() => navigate("/"))}
        className="flex items-center justify-center"
      >
        <svg
          className="w-8 h-8 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 12h14M5 12l4-4m-4 4 4 4"
          />
        </svg>
      </button>
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
    </div>
  );
}
